import React from 'react';
import $ from "jquery";
require('../libs/bootstrap3-typeahead.js');

import { sendRequest } from '../global.js';

export default class TextInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      object: this.props.object,
      properties: this.props.properties,
      options: [],
    };
  }

  handleChange = (e) => {
    this.onChange(e.target.value);
  }

  onChange = (value) => {
    const properties = this.state.properties;
    // options request
    if (properties.minSearch || properties.options) {
      this.getOptions(value);
    }
    // autocomplete from templates
    if (properties.template_mapping && this.state.options) {
      this.state.options.forEach(template => {
        if (value.toLowerCase() === template["name"].toLowerCase()) {
          Object.keys(template).forEach(templateKey => {
            const mappedKey = properties.template_mapping[templateKey];
            if (mappedKey) {
              this.props.onChange(mappedKey, template[templateKey]);
            }
          });
        }
      });
    }

    this.setState({object: value});
    this.props.onChange(this.props.objectKey, value);
  }

  componentDidMount = () => {
    this.getOptions();
  }

  getOptions = (input) => {
    var properties = this.state.properties;
    if (properties.options) {
      this.setOptions(properties.options);
      return;
    }
    let displayKey = properties.displayField || "name";
    var request = properties.request;
    // Load select options and autocomplete if edit is enabled 
    if (!request || properties.hostProperty) {
      return;
    }
    if (request.match(/:id/)) {
      if (this.props.parentId) {
        request = request.replace(":id", this.props.parentId);
      } else {
        return;
      }
    }
    var data = {scope: "headers"};
    if (properties.minSearch) {
      if (!input || input.length < properties.minSearch) {
        if (this.state.options && this.state.options.length > 0) {
          this.setState({options: []});
        }
        return;
      }
      data[displayKey] = input;
    } else if (this.props.objectKey.match(/extra/)) {
      data[properties.idParameter] = properties.id; 
    } else {
      data.name = this.props.objectKey;
    }
    
    sendRequest({
      method: request,
      type: "GET",
      data: data,
      success: (data) => {
        data = data.filter(datum => !!datum);
        if (properties.template_mapping) {
          this.setState({options: data});
          data = data.map(datum => datum["name"]);
        }
        this.setOptions(data);
      },
      error: (xhr, status, err) => {
      }
    });
  }

  setOptions = (data) => {
    let input = $(this.input);
    if (input.parent().find(".typeahead").length === 0) {
      input.typeahead({source: data, showHintOnFocus: true});
      input.on("change", this.handleChange);
    } else {
      input.typeahead("setSource", data);
    }
    if (input.is(":focus") && data.length > 1) {
      input.typeahead("lookup", );
      input.focus();
    }
  }

  componentWillReceiveProps = (props) => {
    if (typeof props.object !== "undefined" && props.object !== null) {
      this.setState({object: props.object});
    }
  }

  render = () => {
    var properties = this.state.properties;

    if (properties.type === "text" || properties.type === "password") {
      return (
        <div className='inputContainer'>
          {properties.clearable ?
            <div
              className='clearButton'
              onClick={() => this.onChange('')}
            >×</div>
          : null}
          <input
            type={properties.type}
            value={this.state.object}
            onChange={this.handleChange}
            readOnly={this.props.disabled}
            className="form-control"
            placeholder={this.props.placeholder}
            ref={(input) => {this.input = input}}
          />
        </div>
      )
    }

    if (properties.type === "textarea") {
      return (
        <textarea 
          value={this.state.object}
          onChange={this.handleChange}
          readOnly={this.props.disabled}
          className="form-control"
          placeholder={this.props.placeholder}
          ref={(input) => {this.input = input}}
        />
      ) 
    }
  }
}



// WEBPACK FOOTER //
// ./src/input/TextInput.js